import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-marketplace-icon',
  templateUrl: './marketplace-icon.component.html',
  styles: []
})
export class MarketplaceIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
